import { startApp } from "@/App";
import { initViewportSize } from "@/hooks/initViewportSize";
import CKEditor from "@ckeditor/ckeditor5-vue";
import VConsole from "vconsole";
import "./style.less";
import router from "./router";

function shouldEnableVConsole() {
  try {
    const searchParams = new URLSearchParams(window.location.search);
    const hashParams = new URLSearchParams(window.location.hash.split("?")[1] || "");
    return (
      searchParams.get("vconsole") === "1" ||
      searchParams.get("debug") === "1" ||
      hashParams.get("vconsole") === "1" ||
      hashParams.get("debug") === "1" ||
      localStorage.getItem("vconsole") === "1"
    );
  } catch {
    return false;
  }
}

if (shouldEnableVConsole()) {
  new VConsole();
  console.log("[vconsole] enabled");
}

// import VConsole from 'vconsole';
// const vConsole = new VConsole();

document.title = "分享";
startApp(router, [initViewportSize], (app) => {
  app.use(CKEditor);
});
